
import Vue from 'vue'
import axios from 'axios'
import { TranslateResult } from "vue-i18n";
import { BugReportType } from "@/constants/enums"

export default Vue.extend({
  name: "ReportBugDialog",
  watch: {
    selectedIssue(){
      this.$refs.form.resetValidation()
    }
  },
  props: {
    clinicName: String
  },
  data(): {
    errorMessage: string
    sending: boolean,
    validForm: boolean,
    isOpen: boolean,
    choices: {text: TranslateResult, value: string}[],
    selectedIssue: string,
    comments: string,
    reportSent: boolean
    } {
      return {
        errorMessage: "",
        sending: false,
        validForm: false,
        isOpen: false,
        choices: [
          {text: this.$t("form.reportBugDialog.choices.UIIssue"), value: BugReportType.UIISSUE},
          {text: this.$t("form.reportBugDialog.choices.cannotSubmitForm"), value: BugReportType.CANNOTSUBMIT},
          {text: this.$t("form.reportBugDialog.choices.loadSlow"), value: BugReportType.SLOWLOAD},
          {text: this.$t("form.reportBugDialog.choices.other"), value: BugReportType.OTHER}
        ],
        selectedIssue: "",
        comments: "",
        reportSent: false
      }
    },
  computed: {
    issueSelectRules(): Function[] {
      return [(v: string) => !!v || this.$t('form.formPages.inputErrors.pleaseSelect')]
    },
  },
  methods: {
    async sendReport() {
      this.sending = true
      try {
        interface BugReport {
          Clinic_Name: string,
          Issue: string
          Comments: string
          User_Agent_String: string
        }
        const bugReport: BugReport = {
          Clinic_Name: this.clinicName,
          Issue: this.selectedIssue,
          Comments: this.comments,
          User_Agent_String: window.navigator.userAgent,
        }
        let payloadText = ''
        Object.entries(bugReport).forEach(([key,value]) => {
          payloadText += `*${key}:* ${value}\n`
        })
        const payload = {
          blocks: [
            {
              type: 'section',
              text: {
                type: 'mrkdwn',
                text: payloadText,
              },
            },
          ],
        }
        const hook = process.env.BUG_REPORT_WEBHOOK
        const headers = {
          'Content-Type': 'application/x-www-form-urlencoded',
        }
        return await axios
          .post(hook, payload, { headers })
          .then((response) => {
            return response
          })
          .then(() => {
            this.reportSent = true
            this.clearForm()
          })
          .catch((err) => {
            throw err.response
          })
          .finally(() => this.sending = false)
      } catch (err) {
        // TODO: Better error catching
        this.$sentry.captureException(err)
        this.errorMessage = this.$t("form.reportBugDialog.sendError")
      }
    },
    clearForm() {
      this.selectedIssue = ""
      this.comments = ""
      this.$refs.form?.resetValidation?.()
    },
    resetDialog() {
      this.clearForm()
      this.reportSent = false
      this.isOpen = false
    }
  }
})
